import { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeInRule = css`
  ${fadeIn} 0.3s linear
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(30px);
  }
`;

export const fadeOutRule = css`
  ${fadeOut} 0.3s cubic-bezier(.165,.84,.44,1)
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideInRule = css`
  ${slideIn} 0.3s cubic-bezier(.165,.84,.44,1)
`;
